import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchVisits = async ({ trialId, patientId, selectedSessionId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!patientId) params.append("patient_id", patientId);
  if (selectedSessionId) params.append("special_visit_sessionId", selectedSessionId);

  const URL = `${__API_URL__}/api/photos/get_visits/${trialId}/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetVisits = ({ trialId, patientId, selectedSessionId, enabled = true }) => {
  return useQuery({
    queryKey: ["visits", trialId, patientId, selectedSessionId],
    queryFn: () => fetchVisits({ trialId, patientId, selectedSessionId }),
    enabled: enabled && Boolean(trialId && trialId > 0),
  });
};

export default useGetVisits;
